import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'precision' })
export class PrecisionPipe implements PipeTransform {
  transform(value: string, precision: number) {
    return value?.length && !isNaN(Number(value))
      ? Number(value) < 1 && Number(value) > 0
        ? '< 1'
        : parseFloat(Number(value).toFixed(precision))
      : '';
  }
}
